import { FC } from 'react';
import { BeatLoader } from 'react-spinners';
import { UnitFeedItem } from '@/types/unit-feed-item';
import { CallsListItem } from '../calls/components/calls-list-item';
import { ResponseListItem } from '../wellbeing-responses/components/response-list-item';

export type FeedListProps = {
  items: UnitFeedItem[];
  loading?: boolean;
  showEmptyState?: boolean;
};

const getItemKey = (item: UnitFeedItem): string =>
  item.kind === 'call'
    ? `call-${item.call.sessionId}`
    : `${item.kind}-${item.response.id}`;

export const FeedList: FC<FeedListProps> = ({
  items,
  loading,
  showEmptyState = true,
}) => (
  <div aria-label="Unit feed" className="flex flex-col px-6" role="list">
    {loading ? (
      <div aria-label="Loading feed" role="status">
        <BeatLoader />
      </div>
    ) : items.length > 0 ? (
      items.map((item, index) => (
        <div key={getItemKey(item)} role="listitem">
          {item.kind === 'call' ? (
            <CallsListItem
              call={item.call}
              isLast={index === items.length - 1}
              label="Call"
            />
          ) : (
            <ResponseListItem
              isLast={index === items.length - 1}
              label={
                item.kind === 'notification' ? 'Notification' : 'Wellbeing'
              }
              response={item.response}
            />
          )}
        </div>
      ))
    ) : showEmptyState ? (
      <div className="text-xs text-gray-500 italic">
        There are no feed items to display
      </div>
    ) : null}
  </div>
);
